import { Notice } from '@applyboard/crystal-ui'
import { getHelperText } from './utils'
import { DecisionDocumentTags } from '../../../../../utils/enums'
import { DecisionResponseType } from '@applyboard/school-applications-types-lib/dist/src/backend/resources/applications/student-decisions'

type ApplicationDetailCardHelperProps = Readonly<{
  decisionDocumentTag: DecisionDocumentTags
  status?: DecisionResponseType
  hasCondition: boolean
  isRevoked?: boolean
  activeRecord: boolean
}>

export function ApplicationDetailCardHelper(props: ApplicationDetailCardHelperProps) {
  const helperText = getHelperText(
    props.decisionDocumentTag,
    props.status,
    props.hasCondition,
    props.activeRecord,
    props.isRevoked,
  )
  return helperText ? <Notice intent={helperText.intent}>{helperText.label}</Notice> : null
}
